module.exports = {
	"ha": "fha",
	"id": 5.5,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category and MSM Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 88.63636363636364,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#043f61"
					},
					{
						"y": 88.63636363636364,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.0909090909091,
						"dataLabels": {
							"enabled": false,
							"format": "37"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.72727272727273,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#09472e"
					},
					{
						"y": 68.18181818181817,
						"dataLabels": {
							"enabled": false,
							"format": "30"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96,
						"dataLabels": {
							"enabled": false,
							"format": "144"
						},
						"color": "#043f61"
					},
					{
						"y": 94,
						"dataLabels": {
							"enabled": false,
							"format": "141"
						},
						"color": "#0c4250"
					},
					{
						"y": 92,
						"dataLabels": {
							"enabled": false,
							"format": "138"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.66666666666667,
						"dataLabels": {
							"enabled": false,
							"format": "130"
						},
						"color": "#09472e"
					},
					{
						"y": 73.33333333333333,
						"dataLabels": {
							"enabled": false,
							"format": "110"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "124"
						},
						"color": "#043f61"
					},
					{
						"y": 99.19354838709677,
						"dataLabels": {
							"enabled": false,
							"format": "123"
						},
						"color": "#0c4250"
					},
					{
						"y": 96.7741935483871,
						"dataLabels": {
							"enabled": false,
							"format": "120"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.32258064516128,
						"dataLabels": {
							"enabled": false,
							"format": "112"
						},
						"color": "#09472e"
					},
					{
						"y": 75.80645161290323,
						"dataLabels": {
							"enabled": false,
							"format": "94"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.55456570155901,
						"dataLabels": {
							"enabled": false,
							"format": "447"
						},
						"color": "#043f61"
					},
					{
						"y": 99.55456570155901,
						"dataLabels": {
							"enabled": false,
							"format": "447"
						},
						"color": "#0c4250"
					},
					{
						"y": 99.33184855233853,
						"dataLabels": {
							"enabled": false,
							"format": "446"
						},
						"color": "#0d4440"
					},
					{
						"y": 96.88195991091314,
						"dataLabels": {
							"enabled": false,
							"format": "435"
						},
						"color": "#09472e"
					},
					{
						"y": 83.96436525612472,
						"dataLabels": {
							"enabled": false,
							"format": "377"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#043f61"
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#0d4440"
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": false,
							"format": "10"
						},
						"color": "#09472e"
					},
					{
						"y": 66.66666666666666,
						"dataLabels": {
							"enabled": false,
							"format": "8"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.57142857142858,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#043f61"
					},
					{
						"y": 95.71428571428572,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.85714285714286,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.71428571428571,
						"dataLabels": {
							"enabled": false,
							"format": "53"
						},
						"color": "#09472e"
					},
					{
						"y": 57.14285714285714,
						"dataLabels": {
							"enabled": false,
							"format": "40"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.4186046511628,
						"dataLabels": {
							"enabled": false,
							"format": "171"
						},
						"color": "#043f61"
					},
					{
						"y": 97.09302325581395,
						"dataLabels": {
							"enabled": false,
							"format": "167"
						},
						"color": "#0c4250"
					},
					{
						"y": 94.76744186046511,
						"dataLabels": {
							"enabled": false,
							"format": "163"
						},
						"color": "#0d4440"
					},
					{
						"y": 86.04651162790698,
						"dataLabels": {
							"enabled": false,
							"format": "148"
						},
						"color": "#09472e"
					},
					{
						"y": 58.139534883720934,
						"dataLabels": {
							"enabled": false,
							"format": "100"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.95615866388309,
						"dataLabels": {
							"enabled": false,
							"format": "474"
						},
						"color": "#043f61"
					},
					{
						"y": 94.36325678496868,
						"dataLabels": {
							"enabled": false,
							"format": "452"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.69311064718163,
						"dataLabels": {
							"enabled": false,
							"format": "444"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.96868475991648,
						"dataLabels": {
							"enabled": false,
							"format": "407"
						},
						"color": "#09472e"
					},
					{
						"y": 66.17954070981212,
						"dataLabels": {
							"enabled": false,
							"format": "317"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 74.57627118644068,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#043f61"
					},
					{
						"y": 74.57627118644068,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0c4250"
					},
					{
						"y": 74.57627118644068,
						"dataLabels": {
							"enabled": false,
							"format": "44"
						},
						"color": "#0d4440"
					},
					{
						"y": 66.10169491525424,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#09472e"
					},
					{
						"y": 52.54237288135594,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 93.97590361445783,
						"dataLabels": {
							"enabled": false,
							"format": "78"
						},
						"color": "#043f61"
					},
					{
						"y": 86.74698795180723,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.72289156626506,
						"dataLabels": {
							"enabled": false,
							"format": "67"
						},
						"color": "#0d4440"
					},
					{
						"y": 71.08433734939759,
						"dataLabels": {
							"enabled": false,
							"format": "59"
						},
						"color": "#09472e"
					},
					{
						"y": 51.80722891566265,
						"dataLabels": {
							"enabled": false,
							"format": "43"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.0414201183432,
						"dataLabels": {
							"enabled": false,
							"format": "164"
						},
						"color": "#043f61"
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": false,
							"format": "143"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.84023668639054,
						"dataLabels": {
							"enabled": false,
							"format": "140"
						},
						"color": "#0d4440"
					},
					{
						"y": 75.7396449704142,
						"dataLabels": {
							"enabled": false,
							"format": "128"
						},
						"color": "#09472e"
					},
					{
						"y": 63.31360946745562,
						"dataLabels": {
							"enabled": false,
							"format": "107"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.94520547945206,
						"dataLabels": {
							"enabled": false,
							"format": "429"
						},
						"color": "#043f61"
					},
					{
						"y": 85.84474885844749,
						"dataLabels": {
							"enabled": false,
							"format": "376"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.01826484018264,
						"dataLabels": {
							"enabled": false,
							"format": "368"
						},
						"color": "#0d4440"
					},
					{
						"y": 79.68036529680366,
						"dataLabels": {
							"enabled": false,
							"format": "349"
						},
						"color": "#09472e"
					},
					{
						"y": 66.43835616438356,
						"dataLabels": {
							"enabled": false,
							"format": "291"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -11.363636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.128205128205132,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.513513513513509,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.083333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.127659574468088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.797101449275366,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.8064516129032251,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4390243902439046,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.666666666666665,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.07142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.44543429844098315,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.22371364653244186,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4663677130044803,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.090909090909093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.999999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.4285714285714235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.898550724637683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.985074626865669,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.461538461538463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.52830188679245,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.5813953488372103,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3391812865497075,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.39520958083832,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.202453987730063,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -32.432432432432435,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.043841336116913,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.641350210970463,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.7699115044247815,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.11302211302212,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -25.423728813559322,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.363636363636365,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.512820512820518,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -6.024096385542165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.944444444444442,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.940298507462687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.118644067796616,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.9585798816568087,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.804878048780488,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0979020979020935,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.571428571428575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.40625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.0547945205479423,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.354312354312357,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.127659574468088,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.163043478260865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.6189111747851,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=44"
			},
			{
				"x": 9,
				"text": "30-39<br>n=150"
			},
			{
				"x": 15,
				"text": "40-49<br>n=124"
			},
			{
				"x": 21,
				"text": ">=50<br>n=449"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=12"
			},
			{
				"x": 34,
				"text": "30-39<br>n=70"
			},
			{
				"x": 40,
				"text": "40-49<br>n=172"
			},
			{
				"x": 46,
				"text": ">=50<br>n=479"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=59"
			},
			{
				"x": 59,
				"text": "30-39<br>n=83"
			},
			{
				"x": 65,
				"text": "40-49<br>n=169"
			},
			{
				"x": 71,
				"text": ">=50<br>n=438"
			}
		],
		"dataTable": {
			"MSM:<30": [
				44,
				39,
				39,
				37,
				32,
				30
			],
			"MSM:30-39": [
				150,
				144,
				141,
				138,
				130,
				110
			],
			"MSM:40-49": [
				124,
				124,
				123,
				120,
				112,
				94
			],
			"MSM:>=50": [
				449,
				447,
				447,
				446,
				435,
				377
			],
			"Non-MSM:<30": [
				12,
				11,
				11,
				11,
				10,
				8
			],
			"Non-MSM:30-39": [
				70,
				69,
				67,
				65,
				53,
				40
			],
			"Non-MSM:40-49": [
				172,
				171,
				167,
				163,
				148,
				100
			],
			"Non-MSM:>=50": [
				479,
				474,
				452,
				444,
				407,
				317
			],
			"Unknown:<30": [
				59,
				44,
				44,
				44,
				39,
				31
			],
			"Unknown:30-39": [
				83,
				78,
				72,
				67,
				59,
				43
			],
			"Unknown:40-49": [
				169,
				164,
				143,
				140,
				128,
				107
			],
			"Unknown:>=50": [
				438,
				429,
				376,
				368,
				349,
				291
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_5.json
// module id = 204
// module chunks = 0